import React from 'react';
import { Icon } from 'antd';
import { Overlay } from './styles';

const LoadSpinnerOverlay = ({ icon, text, ...rest }) => (
  <Overlay
    {...rest}
    text={text}
    size="large"
    color="clientPrimary"
    indicator={(
      <Icon
        type={icon || 'sync'}
        spin
      />
    )}
  />
);

export default LoadSpinnerOverlay;
